import { useMediaQuery } from 'react-responsive';
import { Trans, useTranslation } from 'next-i18next';
import { StrongText } from '@/components/StrongText';
import { cn } from '@/utils/tailwind.util';
import { useAiBuilderChatAvailability, useOpenAiBuilderChat } from '@/views/build/features/ai-builder-chat/hooks';
import { useQuizList } from '../useQuizList';
import { AiFileButton } from './AiFileButton';
import { AiQueryButton } from './AiQueryButton';
import { AiWebsiteButton } from './AiWebsiteButton';
import { AiYoutubeButton } from './AiYoutubeButton';
type BuildAiButtonsLayoutMode = 'page' | 'ai-shell';
export const BuildAiButtons = ({
  layoutMode = 'page'
}: {
  layoutMode?: BuildAiButtonsLayoutMode;
}) => {
  const {
    canUseAiBuilderChat
  } = useAiBuilderChatAvailability();
  if (!canUseAiBuilderChat) return null;
  return <BuildAiButtonsContent layoutMode={layoutMode} data-sentry-element="BuildAiButtonsContent" data-sentry-component="BuildAiButtons" data-sentry-source-file="index.tsx" />;
};
const BuildAiButtonsContent = ({
  layoutMode
}: {
  layoutMode: BuildAiButtonsLayoutMode;
}) => {
  const {
    quizList
  } = useQuizList();
  const isButtonFull = quizList.length === 0;
  const usesAiShellMobileLayout = useMediaQuery({
    maxWidth: '1024px'
  });
  const hideBot = useMediaQuery({
    maxWidth: '580px'
  });
  const shouldHideBot = hideBot || layoutMode === 'ai-shell' && usesAiShellMobileLayout;
  const openAiBuilderChat = useOpenAiBuilderChat();
  return <div className={cn(['mb-lg px-md py-lg relative', layoutMode === 'ai-shell' ? 'min-[1025px]:px-lg min-[1025px]:pt-xl min-[1025px]:pb-lg' : 'tablet-sm:px-lg tablet-sm:pt-xl tablet-sm:pb-lg', 'flex flex-col gap-[12px] rounded-md border-1 border-assistive shadow-xs bg-default'])} data-sentry-component="BuildAiButtonsContent" data-sentry-source-file="index.tsx">
      <Label hideBot={shouldHideBot} data-sentry-element="Label" data-sentry-source-file="index.tsx" />
      <div className={cn('grid grid-cols-1 gap-sm', layoutMode === 'ai-shell' ? 'min-[1025px]:grid-cols-2' : 'tablet-sm:grid-cols-2')}>
        <AiQueryButton onOpenAiBuilderChat={() => openAiBuilderChat({
        entry: 'chat',
        source: 'ai_buttons'
      })} isFull={isButtonFull} data-sentry-element="AiQueryButton" data-sentry-source-file="index.tsx" />
        <AiFileButton onOpenAiBuilderChat={() => openAiBuilderChat({
        entry: 'file',
        source: 'ai_buttons'
      })} isFull={isButtonFull} data-sentry-element="AiFileButton" data-sentry-source-file="index.tsx" />
        <AiYoutubeButton onOpenAiBuilderChat={() => openAiBuilderChat({
        entry: 'youtube',
        source: 'ai_buttons'
      })} isFull={isButtonFull} data-sentry-element="AiYoutubeButton" data-sentry-source-file="index.tsx" />
        <AiWebsiteButton onOpenAiBuilderChat={() => openAiBuilderChat({
        entry: 'website',
        source: 'ai_buttons'
      })} isFull={isButtonFull} data-sentry-element="AiWebsiteButton" data-sentry-source-file="index.tsx" />
      </div>
    </div>;
};
const Label = ({
  hideBot
}: {
  hideBot: boolean;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <div className={'flex items-center gap-3xs'} data-sentry-component="Label" data-sentry-source-file="index.tsx">
      <span className={'break-keep text-start text-body-lg-bold text-default'}>
        <Trans t={t} i18nKey={'build.ai.recommendAiQuiz'} components={{
        Comp: <StrongText text={t('ai.resultDescription.accent')} />
      }} data-sentry-element="Trans" data-sentry-source-file="index.tsx" />
        {/*<QUIZ AI를 이용해 다양한 문제를 빠르게 만들어 보세요*/}
      </span>
      {!hideBot && <div className={'absolute right-[2%] tablet-sm:right-6'}>
          <img src="/assets/aiRobot.png" alt="" width={82} height={82} />
        </div>}
    </div>;
};